module.exports = __webpack_public_path__ + "imgs/star-full-gray.da03a76077beb0bd90cab2d69da75691.svg";